<script>
import { mapGetters } from 'vuex'
import { useCases } from 'frontend-js-shared'

export default {
  computed: {
    ...mapGetters(['account', 'organizationSiteGroups']),
  },

  methods: {
    getTeamPermissions({ team } = {}) {
      return useCases.teams.getPermissions({
        team,
        currentAccount: this.account,
        organizationSiteGroups: this.organizationSiteGroups,
      })
    },
  },
}
</script>
